import { stampAt, minutesToTime, stripAccents } from "./utils";
import { SEED_APPLICATIONS } from "./applications";

export const STORAGE_KEY = "upv_foro_2027_state";
export const STATE_VERSION = 1;
export const DEMO_DAY = 2;

export const TITULACIONES = {
  "Ingeniería Informática": "ETSIINF",
  "Ciencia de Datos": "ETSIINF",
  "Ingeniería Industrial": "ETSII",
  "Ingeniería Eléctrica": "ETSII",
  "Ingeniería Química": "ETSII",
  Telecomunicaciones: "ETSIT",
  "Administración y Dirección de Empresas": "FADE",
  "Ingeniería Civil": "ETSICCP",
};
export const TITULACION_LIST = Object.keys(TITULACIONES);
export const shortTit = (t) => (t === "Administración y Dirección de Empresas" ? "ADE" : t);
export const CENTROS = ["ETSIINF", "ETSII", "ETSIT", "FADE", "ETSICCP"];
export const CURSOS = ["1º Grado", "2º Grado", "3º Grado", "4º Grado", "Máster", "Doctorado", "Alumni"];

export const COMPANIES = [
  { id: "bosch", name: "Bosch", sector: "Tecnología e ingeniería", stand: "A-12" },
  { id: "siemens", name: "Siemens", sector: "Industria y energía", stand: "A-08" },
  { id: "ford", name: "Ford", sector: "Automoción", stand: "B-03" },
  { id: "deloitte", name: "Deloitte", sector: "Consultoría", stand: "C-15" },
  { id: "power-electronics", name: "Power Electronics", sector: "Energía", stand: "A-02" },
  { id: "capgemini", name: "Capgemini", sector: "Consultoría tecnológica", stand: "C-04" },
  { id: "accenture", name: "Accenture", sector: "Consultoría", stand: "C-09" },
  { id: "mercadona-tech", name: "Mercadona Tech", sector: "Retail tech", stand: "B-11" },
];
export const companyName = (id) => COMPANIES.find((c) => c.id === id)?.name || id;

export const DEVICES = [
  { id: "RD-01", label: "Recruiter Device 01" },
  { id: "RD-02", label: "Recruiter Device 02" },
  { id: "RD-03", label: "Recruiter Device 03" },
];

export const CHECKPOINTS = [
  { id: "entrada-principal", name: "Entrada Principal", mode: "entry" },
  { id: "entrada-norte", name: "Entrada Norte", mode: "entry" },
  { id: "salida-principal", name: "Salida Principal", mode: "exit" },
  { id: "salida-norte", name: "Salida Norte", mode: "exit" },
];
export const checkpointName = (id) => CHECKPOINTS.find((c) => c.id === id)?.name || id;

const RAW = [
  ["María", "García López", "F", "Ingeniería Informática", "4º Grado", "7FH29KD8"],
  ["José", "Martínez Ruiz", "M", "Ingeniería Industrial", "Máster", "K3M8Q2LA"],
  ["Ana", "Torres Pérez", "F", "Telecomunicaciones", "4º Grado", "R7T2W9XB"],
  ["Pablo", "Sánchez Navarro", "M", "Ingeniería Informática", "3º Grado", "H4N6P2QZ"],
  ["Lucía", "Fernández Gil", "F", "Ciencia de Datos", "4º Grado", "B9X3K7MT"],
  ["Javier", "Moreno Castillo", "M", "Ingeniería Eléctrica", "Máster", "W2R8L5CJ"],
  ["Carmen", "Romero Vidal", "F", "Administración y Dirección de Empresas", "4º Grado", "M6V4T9NA"],
  ["Alejandro", "Ortega Serrano", "M", "Ingeniería Civil", "Máster", "Q8Z2H5RK"],
  ["Laura", "Jiménez Molina", "F", "Ingeniería Química", "4º Grado", "D3J7W4XP"],
  ["Daniel", "Navarro Blasco", "M", "Telecomunicaciones", "Máster", "L5B9N2TF"],
  ["Marta", "Ruiz Esteve", "F", "Ingeniería Industrial", "4º Grado", "T7K3R8ME"],
  ["Sergio", "Gómez Ferrer", "M", "Ingeniería Informática", "Máster", "Z4P6C2HW"],
  ["Paula", "Martín Soler", "F", "Administración y Dirección de Empresas", "Máster", "N8F3X7LB"],
  ["Adrián", "López Mora", "M", "Ciencia de Datos", "3º Grado", "C2W9M4QS"],
  ["Elena", "Díaz Campos", "F", "Ingeniería Informática", "Alumni", "J6T5Z8KD"],
  ["Raúl", "Hernández Peris", "M", "Ingeniería Industrial", "3º Grado", "X3L7B2RN"],
  ["Sara", "Vicente Llorens", "F", "Telecomunicaciones", "3º Grado", "F9Q4H6TC"],
  ["Iván", "Pascual Roig", "M", "Ingeniería Eléctrica", "4º Grado", "P5M2W8JZ"],
  ["Claudia", "Ibáñez Marco", "F", "Ingeniería Civil", "4º Grado", "V7D3K9LA"],
  ["Marcos", "Cano Sanchis", "M", "Administración y Dirección de Empresas", "3º Grado", "S4N8T2XF"],
  ["Nuria", "Alonso Domingo", "F", "Ingeniería Química", "Máster", "G6R5C9MB"],
  ["Hugo", "Crespo Andrés", "M", "Ingeniería Informática", "4º Grado", "Y2H7P4WK"],
  ["Irene", "Sanz Bernabeu", "F", "Ciencia de Datos", "Máster", "E8L3Z6QN"],
  ["Diego", "Lorente Cuesta", "M", "Telecomunicaciones", "4º Grado", "U5X9F2TD"],
  ["Andrea", "Gimeno Part", "F", "Ingeniería Industrial", "Máster", "A7C4N8JR"],
  ["Óscar", "Rubio Tormo", "M", "Ingeniería Civil", "3º Grado", "K9W2T5MH"],
  ["Natalia", "Peña Ballester", "F", "Administración y Dirección de Empresas", "4º Grado", "R3P8B6LX"],
  ["Víctor", "Marí Climent", "M", "Ingeniería Informática", "3º Grado", "H5Z4Q9CF"],
  ["Julia", "Esteban Calvo", "F", "Ingeniería Eléctrica", "Máster", "B2M7X3TW"],
  ["Álvaro", "Requena Bou", "M", "Ingeniería Industrial", "Alumni", "W8K6D4NP"],
];

const DNI_LETTERS = "TRWAGMYFPDXBNJZSQVHLCKE";
const slug = (s) => stripAccents(s).toLowerCase().replace(/\s+/g, "");

function makeParticipant([firstName, lastName, gender, titulacion, curso, tok], i) {
  const num = (12345678 + i * 731911) % 100000000;
  const ph = String(12345678 + i * 104729).slice(0, 8);
  const l1 = lastName.split(" ")[0];
  return {
    id: `p${String(i + 1).padStart(2, "0")}`,
    token: `UPV-P-${tok}`,
    firstName,
    lastName,
    gender,
    dni: String(num).padStart(8, "0") + DNI_LETTERS[num % 23],
    email: `${slug(firstName)}.${slug(l1)}@alumni.upv.es`,
    phone: `+34 6${ph.slice(0, 2)} ${ph.slice(2, 5)} ${ph.slice(5, 8)}`,
    centro: TITULACIONES[titulacion],
    titulacion,
    curso,
    linkedin: `linkedin.com/in/${slug(firstName)}${slug(lastName)}`,
    cvFileName: `CV_${stripAccents(firstName)}_${stripAccents(l1)}.pdf`,
    cvUploaded: false,
    registeredAt: 0,
  };
}

const BOSCH_SEED = [
  [2, 1, "11:47", "RD-01"], [3, 1, "11:52", "RD-02"], [4, 1, "10:15", "RD-01"],
  [12, 1, "12:30", "RD-03"], [22, 1, "16:05", "RD-02"], [28, 1, "17:20", "RD-01"],
  [5, 2, "09:58", "RD-01"], [10, 2, "10:24", "RD-02"], [14, 2, "10:41", "RD-03"],
  [16, 2, "11:05", "RD-01"], [18, 2, "11:18", "RD-02"], [24, 2, "11:31", "RD-03"],
];
const OTHER = COMPANIES.slice(1).map((c) => c.id);
const pid = (n) => `p${String(n).padStart(2, "0")}`;

function seedAccess() {
  const ev = [];
  for (let i = 2; i <= 20; i++) {
    ev.push({ id: `a-${i}-1`, participantId: pid(i), checkpointId: i % 3 ? "entrada-principal" : "entrada-norte", type: "entry", ...stampAt(2, minutesToTime(510 + i * 7)) });
    if (i % 4 === 0) ev.push({ id: `a-${i}-2`, participantId: pid(i), checkpointId: "salida-principal", type: "exit", ...stampAt(2, minutesToTime(660 + i * 5)) });
    if (i % 8 === 0) ev.push({ id: `a-${i}-3`, participantId: pid(i), checkpointId: "entrada-principal", type: "entry", ...stampAt(2, minutesToTime(780 + i * 3)) });
  }
  return ev;
}

function seedInteractions() {
  const list = BOSCH_SEED.map(([n, day, time, deviceId]) => ({
    id: `i-bosch-${n}`, participantId: pid(n), companyId: "bosch", deviceId, method: "QR", ...stampAt(day, time),
  }));
  for (let i = 2; i <= 30; i++) {
    const c1 = OTHER[(i * 3) % 7];
    const c2 = OTHER[(i * 5 + 2) % 7];
    const day = i % 3 === 0 ? 1 : 2;
    list.push({ id: `i-${c1}-${i}`, participantId: pid(i), companyId: c1, deviceId: "RD-01", method: "QR", ...stampAt(day, minutesToTime(560 + i * 9)) });
    if (c2 !== c1) list.push({ id: `i-${c2}-${i}`, participantId: pid(i), companyId: c2, deviceId: "RD-02", method: "QR", ...stampAt(day, minutesToTime(600 + i * 11)) });
  }
  return list;
}

export const createSeedState = () => ({
  version: STATE_VERSION,
  activeParticipantId: "p01",
  participants: RAW.map(makeParticipant),
  accessEvents: seedAccess(),
  interactions: seedInteractions(),
  companyApplications: SEED_APPLICATIONS.map((a) => ({ ...a })),
});
